<script lang="ts">
import {espHomeEvent} from '../state.svelte';

</script>
<div>
  EspHomeEvent: {espHomeEvent.data}
</div>
